export default __webpack_public_path__ + "static/media/sucess.0ecfefed.png";